<template>
  <div class="modal-content">
    <h3 class="title">Паевый фонд</h3>
    <h4 class="stock-name">
      {{ stock.issuer }}
    </h4>
    <h5 class="stock-code">{{ stock.isin }}</h5>
    <div class="row row_justify-between">
      <div class="column">
        <span class="cost-label">Стоимость пая</span>
        <span class="stock-cost"
          >{{ stock.price }} {{ getCurrencySign(stock.currency) }}</span
        >
      </div>
      <div class="column">
        <span class="status-label">Рыночный статус</span>
        <span class="stock-status">Торги открыты</span>
      </div>
    </div>
    <div class="chart">
      График появится в ближайшее время
    </div>
    <div class="inputs">
      <div class="row row_justify-between inputs-row">
        <modal-input
          class="modal-input"
          componentID="stock-amount"
          labelText="Количество"
        />
        <modal-input
          class="modal-input"
          componentID="stock-price"
          labelText="Цена"
        />
      </div>
      <modal-input
        class="modal-input"
        componentID="stock-execution-type"
        labelText="Тип исполнения"
      />
    </div>
    <div class="row buttons">
      <button class="button filled">Покупка</button>
      <button class="button filled">Продажа</button>
    </div>
  </div>
</template>

<script>
import { getCurrencySign } from "@/helpers/money";
import ModalInput from "@/components/stock/ModalInput";

export default {
  props: {
    stock: Object
  },
  components: {
    "modal-input": ModalInput
  },
  methods: {
    getCurrencySign
  }
};
</script>

<style scoped>
.modal-content {
  color: #222c44;
}

.row {
  display: flex;
}

.row_justify-between {
  justify-content: space-between;
}

.column {
  display: flex;
  flex-direction: column;
}

.title {
  font-size: 36px;
  font-weight: 400;
}

.stock-name {
  margin-top: 20px;
  font-size: 24px;
  font-weight: 400;
}

.stock-code {
  margin: 10px 0 20px;
  font-size: 20px;
  text-transform: uppercase;
  font-weight: 400;
  color: #9196a2;
}

.cost-label,
.status-label {
  font-size: 15px;
  font-weight: 400;
  color: #acb5c5;
}

.stock-cost,
.stock-status {
  margin-top: 7px;
  font-size: 20px;
}

.stock-status {
  color: #5ac480;
}

.chart {
  margin: 20px 0;
  height: 20vh;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #767d8a;
  background-color: #acb5c5;
}

.inputs-row {
  margin-bottom: 10px;
}

.buttons {
  margin-top: 20px;
}

.button {
  margin-right: 10px;
  padding: 15px 30px;
}
</style>
